<template>
  <div class="i-cell-value">
    <label>
        {{ formatSize(item.filesize) }}
    </label>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { humanFileSize } from '@/utils/tools';

export default defineComponent({
  props: {
    item: Object,
  },
  computed: {
  },
  methods: {
    formatSize(filesize) {
      if (!filesize) return '';
      return humanFileSize(filesize);
    },
  },
});
</script>

<style scoped lang="scss">

</style>
